import { useTranslation } from 'react-i18next';
import { makeStyles } from '@material-ui/core/styles';
import { color } from '../../app/theme';
import Tag from '../shared/Tag';

const useStyles = makeStyles(
  {
    root: {
      marginBottom: 16,
    },
    line: {
      flexGrow: 1,
      borderBottom: `1px solid ${color.$9}`,
    },
    text: {
      margin: '0 16px',
      maxWidth: '80%',
      overflow: 'hidden',
      whiteSpace: 'nowrap',
      textOverflow: 'ellipsis',
      fontSize: '13px',
      fontWeight: 'normal',
      fontStretch: 'normal',
      fontStyle: 'normal',
      letterSpacing: 'normal',
      color: color.$11,
    },
    order: { display: 'flex', alignItems: 'center', marginBottom: 24 },
    tagBlock: {
      textAlign: 'center',
    },
    tag: {
      marginBottom: 8,
    },
  },
  {
    name: 'PreviewTagNode',
  },
);

const PreviewTagNode = ({ node }) => {
  const classes = useStyles();
  const { t } = useTranslation();
  const { data } = node || {};
  const { tags = [] } = data || {};

  return (
    <div className={classes.root}>
      <div className={classes.order}>
        <span className={classes.line} />
        <span className={classes.text}>{t('tag-node')}</span>
        <span className={classes.line} />
      </div>
      <div className={classes.tagBlock}>
        {(tags || []).map((tag, idx) => (
          <Tag
            className={classes.tag}
            size="M"
            tag={tag}
            key={`preview-tags-${idx}`}
            clickable
            idx={idx}
            color="colorPrimary"
            deleteable={false}
            isShowDelete={false}
          />
        ))}
      </div>
    </div>
  );
};

export default PreviewTagNode;
